import Configuration from '@/agilis/util/Configuration'
import FileUploaderMixin from './FileUploaderMixin.js'
import L from 'lodash'
import { mapGetters } from 'vuex'
import Vue from 'vue'

export default {
  mixins: [
    FileUploaderMixin
  ],
  data () {
    return {
      attachmentDialog: false,
      itemDTO: {},
      fileSelectedArray: [],
      formData: new FormData()
    }
  },

  mounted () {
    this.fetchFiles()
    this.itemDTO = Configuration.datatable.getDTO(this.attachmentTable)
  },

  computed: {
    ...mapGetters({
      loading: 'loaderStore/loading'
    }),
    attachmentTable () {
      return this.trackerType.attachmentTable
    }
  },

  methods: {
    fetchFiles () {
      // attachments require openkm in the environment
      if (this.$envmap.VUE_APP_AGILIS_ATTACHMENT_DISABLE !== true) {
        this.startLoader({ id: 'tracker-attachments' })
        const url = Vue.axios.agilisUrlTrackerAttachmentsV2(
          this.applicationId,
          this.trackerTypeId,
          this.trackerId)
        Vue.axios.get(url, Vue.axios.agilisRequestConfig(url)).then(response => {
          this.fileArray = response.data.trackerAttachments || []
        }).catch(error => {
          this.notifyError(error)
        }).finally(() => {
          this.stopLoader({ id: 'tracker-attachments' })
        })
      }
    },

    onFilePicked (event) {
      const files = event.target.files
      let tempFileArray = []
      let droppedFiles = []

      const uploadID = Date.now()
      this.startProgress({ id: 'attachments-progress', value: uploadID })

      for (var i = 0; i < files.length; i++) {
        const validation = this.validateFile(files[i])
        if (validation.valid === true) {
          this.formData.append('files[' + i + ']', files[i])
          tempFileArray.push({ id: uploadID, contentSize: files[i].size, filename: files[i].name })
        } else {
          droppedFiles.push({
            file: files[i],
            errorMessage: validation.errorMessage
          })
        }
      }

      if (droppedFiles.length > 0) {
        const message = droppedFiles.reduce((acc, invalidFile, index, allInvalidFiles) => {
          const line = invalidFile.file.name + ': ' + invalidFile.errorMessage
          return acc + (index > 0 ? '\n' + line : line)
        }, '')
        this.notifyError({ message })
      }

      this.attachmentDialog = true
      this.fileSelectedArray = tempFileArray
      this.stopProgress({ id: 'attachments-progress' })
    },

    onTemplatePicked (event) {
      const files = event.target.files
      let formData = new FormData()
      let tempFileArray = []
      let droppedFiles = []

      const uploadID = Date.now()
      this.startProgress({ id: 'attachments-progress', value: uploadID })

      for (var i = 0; i < files.length; i++) {
        const validation = this.validateTemplateFile(files[i])
        if (validation.valid === true) {
          formData.append('files[' + i + ']', files[i])
          tempFileArray.push({ id: uploadID, contentSize: files[i].size, filename: files[i].name })
        } else {
          droppedFiles.push({
            file: files[i],
            errorMessage: validation.errorMessage
          })
        }
      }

      if (droppedFiles.length > 0) {
        const message = droppedFiles.reduce((acc, invalidFile, index, allInvalidFiles) => {
          const line = invalidFile.file.name + ': ' + invalidFile.errorMessage
          return acc + (index > 0 ? '\n' + line : line)
        }, '')
        this.notifyError({ message })
      }

      if (tempFileArray.length > 0) {
        this.fileArray = [...this.fileArray, ...tempFileArray]
        const url = Vue.axios.agilisUrlTrackerTemplateAttachments(
          this.applicationId,
          this.trackerTypeId,
          this.trackerId)

        Vue.axios.post(url, formData, {
          ...Vue.axios.agilisRequestConfig(url),
          onUploadProgress: (progress) => {
            this.updateProgress({ id: 'attachments-progress', progress })
          }
        }).then(response => {
          this.fetchFiles()
          this.$emit('componentUpdated')
        }).catch(error => {
          // remove the tmp file
          this.fileArray = this.fileArray.filter(f => f.id !== uploadID)

          // Show the error
          this.notifyError(error)
        }).finally(() => {
          // Reset the progress
          this.stopProgress({ id: 'attachments-progress' })
          this.keyResetTemplate = this.keyResetTemplate + 1
        })
      }
    },

    saveFile () {
      if (this.fileSelectedArray.length > 0) {
        if (this.attachmentTable.metaDataMap) {
          this.attachmentTable.metaDataMap.forEach(metadata => {
            if (this.itemDTO && !L.isEmpty(this.itemDTO[metadata])) {
              this.formData.append(metadata, this.itemDTO[metadata])
            }
          })
        }
        const url = Vue.axios.agilisUrlTrackerAttachmentsV2(
          this.applicationId,
          this.trackerTypeId,
          this.trackerId)
        this.startLoader({ id: 'tracker-attachments' })
        Vue.axios.post(url, this.formData, {
          ...Vue.axios.agilisRequestConfig(url),
          onUploadProgress: (progress) => {
            this.updateProgress({ id: 'attachments-progress', progress })
          }
        }).then(response => {
          this.fetchFiles()
          this.$emit('componentUpdated')
          this.closeDialog()
        }).catch(error => {
          // Show the error
          this.notifyError(error)
        }).finally(() => {
          // Reset the progress
          this.stopLoader({ id: 'tracker-attachments' })
          this.stopProgress({ id: 'attachments-progress' })
          this.keyReset = this.keyReset + 1
        })
      }
    },

    onFileClick (attachment, download = true) {
      this.startLoader({ id: 'download-attachment', value: attachment.filename })
      const url = Vue.axios.agilisUrlTrackerAttachmentsV2Edit(
        this.applicationId,
        this.trackerTypeId,
        this.trackerId,
        attachment.filename)
      const requestConfig = Vue.axios.agilisRequestConfig(url)
      requestConfig.responseType = 'blob'
      Vue.axios.get(url, requestConfig).then(response => {
        const blob = new Blob([response.data], { type: attachment.mimeType })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.target = '_blank'

        if (download) {
          link.download = attachment.filename
        } else {
          link.target = '_blank'
        }

        document.body.appendChild(link)
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(error => {
        this.notifyError(error)
      }).finally(() => {
        this.stopLoader({ id: 'download-attachment' })
      })
    },

    async onFileDeleteClick (filename) {
      const userResponse = await this.notifyUserConfirm({
        title: this.$t('label.fileUploadDeleteTitle'),
        messages: [this.$t('label.fileUploadDeleteMessage')],
        confirm: this.$t('label.fileUploadDeleteYes'),
        cancel: this.$t('label.fileUploadDeleteNo')
      })

      if (userResponse) {
        this.startLoader({ id: 'delete-attachment', value: filename })
        const url = Vue.axios.agilisUrlTrackerAttachmentsV2Edit(
          this.applicationId,
          this.trackerTypeId,
          this.trackerId,
          filename)

        Vue.axios.delete(url, Vue.axios.agilisRequestConfig(url)).then(response => {
          this.fetchFiles()
        }).catch(error => {
          this.notifyError(error)
        }).finally(() => {
          this.stopLoader({ id: 'delete-attachment' })
        })
      }
    },

    closeDialog () {
      this.itemDTO = Configuration.datatable.getDTO(this.attachmentTable)
      this.attachmentDialog = false
      this.fileSelectedArray = []
      this.formData = new FormData()
    },

    renderColumn (colId, item) {
      const colConfig = this.trackerType.attachmentTable?.columns[colId]
      return Configuration.datatable.renderColumn(colConfig, item)
    }
  }
}
